import React from "react";
import styled from "@emotion/styled";
import { useNavigate } from "react-router-dom";
import useSWR from "swr";

/**
 * 새 요청 — 타입 선택 메뉴.
 * 요청 종류를 고르면 해당 폼으로 이동한다. (지점 변경 / 상담일지 등록 / ...)
 * 앞으로 매장점검 체크리스트 등 다양한 요청 타입이 여기에 추가된다.
 *
 * 상담일지 등록 요청은 지정 담당자(me.is_consult_register)에게만 노출된다.
 */
const MENU = [
  {
    to: "/new/branch",
    icon: "🏢",
    title: "지점 변경 요청",
    desc: "본인 담당 지점을 변경 요청합니다.",
  },
  {
    to: "/new/consultation",
    icon: "📝",
    title: "상담일지 등록 요청",
    desc: "상담일지를 작성해 승인 요청합니다. 승인되면 임시저장으로 넘어갑니다.",
    requiresConsultRegister: true,
  },
];

function NewRequestPage() {
  const navigate = useNavigate();
  const { data: me } = useSWR("/manager/change-request/me");
  const canConsult = !!me?.is_consult_register;

  const menu = MENU.filter((m) => !m.requiresConsultRegister || canConsult);

  return (
    <Wrapper>
      <Notice>등록할 요청 종류를 선택해주세요.</Notice>
      <List>
        {menu.map((m) => (
          <Item key={m.to} type="button" onClick={() => navigate(m.to)}>
            <Icon>{m.icon}</Icon>
            <Texts>
              <ItemTitle>{m.title}</ItemTitle>
              <ItemDesc>{m.desc}</ItemDesc>
            </Texts>
            <Chevron>›</Chevron>
          </Item>
        ))}
        <ItemDisabled>
          <Icon>✅</Icon>
          <Texts>
            <ItemTitle>매장점검 체크리스트</ItemTitle>
            <ItemDesc>준비 중입니다.</ItemDesc>
          </Texts>
          <Soon>예정</Soon>
        </ItemDisabled>
      </List>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
const Notice = styled.div`
  padding: 12px 14px;
  font-size: 13px;
  line-height: 1.6;
  color: #003580;
  background: #eef3fb;
  border: 1px solid #d6e0f0;
  border-radius: 12px;
`;
const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
const Item = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  text-align: left;
  background: #ffffff;
  border: 1px solid #e6e8eb;
  border-radius: 14px;
  cursor: pointer;
`;
const ItemDisabled = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: #f7f8fa;
  border: 1px solid #eceef1;
  border-radius: 14px;
  opacity: 0.7;
`;
const Icon = styled.span`
  font-size: 22px;
  line-height: 1;
`;
const Texts = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 3px;
`;
const ItemTitle = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: #222;
`;
const ItemDesc = styled.div`
  font-size: 12px;
  color: #888;
  line-height: 1.5;
`;
const Chevron = styled.span`
  font-size: 22px;
  color: #bbb;
`;
const Soon = styled.span`
  flex-shrink: 0;
  padding: 2px 10px;
  font-size: 11px;
  font-weight: 500;
  color: #888;
  background: #eceef1;
  border-radius: 8px;
`;

export default NewRequestPage;
